exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap);", ""]);

// module
exports.push([module.id, ".v-pagination__item[data-v-7762d25a],.v-pagination__item--active[data-v-7762d25a],.v-pagination__navigation[data-v-7762d25a]{box-shadow:0 1px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 2px 0 rgba(0,0,0,.12)}header[data-v-7762d25a]{background-color:var(--v-app-bar-base)!important}.v-app-bar__nav-icon[data-v-7762d25a]{color:var(--v-app-bar-text-base)!important}", ""]);

// exports
